module.exports = __webpack_public_path__ + "img/sonargroup-thumb.3ae24565.jpg";